import React, { Fragment, memo, useState } from "react";
import RpMUIDialog from "./RpMUIModal";
import "./modalStyle.scss";
import { Box } from "@mui/material";
import {
  CreativeMediaContent,
  CreativeMediaDialog,
} from "@/features/campaigns/components/CreativeMediaPreview";
import { getCreativeMediaType } from "@/features/campaigns/shared/helpers/creativePreviewHelper";

const CreativeImagePopup = ({
  src,
  srcTwo,
  children,
  heading = "",
  channelName = "",
  creativeType = "",
  thumbnail = "",
  poster = "",
}) => {
  const [open, setOpen] = useState(false);
  const mediaType = getCreativeMediaType({
    attachment: src,
    channelName,
    creativeType,
  });
  const onClose = () => {
    setOpen(false);
  };
  const handleOpen = () => {
    if (!src) return;
    setOpen(true);
  };
  return (
    <Fragment>
      <div
        onClick={handleOpen}
        className="creative-name link"
        title="Click to view"
      >
        {children}
      </div>
      {mediaType === "image" ? (
        <RpMUIDialog
          open={open}
          onClose={onClose}
          heading={heading}
          maxWidth="xs"
          fullWidth={false}
        >
          <Box
            minWidth={200}
            display="flex"
            justifyContent="center"
            flexDirection="column"
          >
            <CreativeMediaContent
              attachment={src}
              channelName={channelName}
              creativeName={heading}
              creativeType={creativeType}
              mediaType={mediaType}
              imageClassName="img-fluid"
            />
            {srcTwo && srcTwo !== "-" ? (
              <CreativeMediaContent
                attachment={srcTwo}
                channelName={channelName}
                creativeName={heading}
                mediaType="image"
                imageClassName="img-fluid mt-2"
              />
            ) : null}
          </Box>
        </RpMUIDialog>
      ) : (
        <CreativeMediaDialog
          open={open}
          onClose={onClose}
          title={heading}
          channelName={channelName}
          maxWidth="md"
          fullWidth
        >
          <Box
            minWidth={240}
            display="flex"
            justifyContent="center"
            flexDirection="column"
          >
            <CreativeMediaContent
              attachment={src}
              channelName={channelName}
              creativeName={heading}
              creativeType={creativeType}
              thumbnail={thumbnail}
              poster={poster}
              mediaType={mediaType}
              controls
              imageClassName="img-fluid"
            />
          </Box>
        </CreativeMediaDialog>
      )}
    </Fragment>
  );
};

export default memo(CreativeImagePopup);
